import Icon from '../components/Icon.vue';
Icon.register({
  'smile-wink': {
    width: 496,
    height: 512,
    paths: [{
      d: 'M0 256c0-137 111-248 248-248s248 111 248 248-111 248-248 248-248-111-248-248zM200 208c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zM358.5 224.5l9.7 8.5c8.4 7.5 21.5 0.3 19.8-10.8-4-25.2-34.2-42.1-59.9-42.1-25.7 0-55.9 16.9-59.9 42.1-1.8 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM157.8 325.8c-13.4-16.3-38.1 4.1-24.6 20.4 28.5 34.2 70.3 53.8 114.8 53.8s86.3-19.6 114.8-53.7c13.5-16.3-11-36.7-24.6-20.5-22.4 26.8-55.2 42.2-90.2 42.2s-67.8-15.3-90.2-42.2z'
    }]
  }
});